import { v4 as uuidv4 } from 'uuid';
import { UUID } from '../types';

export class RandomizeService {
  static generateUuid(): UUID {
    return uuidv4();
  }
}
